import { useState } from "react";
import { Div } from "../../../../common/ui/widgets";
import moreMenuGray from "../../../../common/icons/webicons/moremenu-gray.svg";
import checkMarkGray from "../../../../common/icons/webicons/checkmark-gray.svg";
import { SelectMenuWrapper, SelectMenuItemWrapper } from "./styles";
import { useTranslation } from "react-i18next";

export default function SelectMenu({ children }) {
  const [showMenu, setShowMenu] = useState(false);
  return (
    <SelectMenuWrapper
      data-test="component-app"
      data-testid="select-menu"
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
    >
      <img data-testid="menu-logo" src={moreMenuGray} alt="menu-logo" />
      {showMenu && <Div>{children}</Div>}
    </SelectMenuWrapper>
  );
}
export const SelectMenuItem = ({ onClick, name = "", translate = "", options }) => {
  const { t } = useTranslation();
  const label = translate ? t(translate) : name;
  return (
    <SelectMenuItemWrapper data-testid="select-menu-item" onClick={onClick}>
      {label}
      {options ? options.checked && <img src={checkMarkGray} loading="lazy" alt="check"/> : ""}
    </SelectMenuItemWrapper>
  );
};
export const SelectMenuData = ({ data = [] }) => {
  const { t } = useTranslation();
  const noDataText = t("There is not enough data to analyze");
  return data.length
    ? data.map(dataItem => (
        <SelectMenuItemWrapper data-test="select-menu-data">
          {dataItem}
        </SelectMenuItemWrapper>
      ))
    : noDataText;
};

